import React from 'react'
import { useFormContext } from 'react-hook-form';
import InputArea from '../../../common/components/FormFields/InputArea';
export default function MedicalHistory(props) {
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  return (
    <div>
      <div className="flex justify-between bg-[#cafee0] rounded-t-md">
        <p className="text-sm font-semibold w-full pl-2 py-1">
          Medical History
        </p>
      </div>
      <div className={`${props.from === "generalEMR" ? "h-24 p-2 pb-2" : props.from === "dental" || props.from === "gyanc" ? "h-48 p-2" : "h-16 p-1"} flex justify-between  border  overflow-auto  border-[#D9D9D9] rounded-b-md bg-white px-2`}>
        <div className="w-full">
          <InputArea
            control={control}
            name="medicalHistory"
            label=" Medical History"
          />
        </div>

      </div>
    </div>
  )
}
